import { Button, useNotify, useRefresh } from "react-admin";
import PaidIcon from "@mui/icons-material/Paid";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";

const MarkPeriodPaidDialog = ({ id, periodId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    await dataProvider.customRequest(
      specialistRequests.markAdvancedSpecializationSpecialistPeriodPaid(id, periodId),
      null,
      "PATCH",
    );
    notify("Периодът е маркиран като платен", { type: "success" });
    refresh();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent="Маркиране като платен"
      saveTitle="Потвърди"
      message="Сигурни ли сте, че искате да маркирате този период като платен?"
      triggerButton={
        <Button
          label="Маркирай платен"
          size="small"
          variant="contained"
          startIcon={<PaidIcon />}
        />
      }
    />
  );
};

export default MarkPeriodPaidDialog;
